export default "__VITE_PUBLIC_ASSET__75d32f63__"